






import { defineComponent } from "@vue/composition-api";
import { TalentAgent } from "@scrile/api-provider/dist/api/TalentAgentsProvider";
import CreatorByTalentRepItem from "../components/CreatorByTalentRepItem.vue";

export default defineComponent({
  name: "CreatorsByTalentRepList",
  components: { CreatorByTalentRepItem },
  props: {
    items: { type: Array as () => TalentAgent[], default: () => [] },
  },
});
